var React = require('react');
var ReactIntl = require('react-intl');
var injectIntl = ReactIntl.injectIntl;
var IntlProvider = ReactIntl.IntlProvider;

var Footer = require('../Footer/Footer');
var Header = require('../Header/Header');
var LoginActions = require('../../actions/LoginActions');
var LoginStore = require('../../stores/LoginStore');
var defaultMessages = require('../../i18n/messages/default');
var PageCase = require('../PageCase/PageCase.js');
var createReactClass = require('create-react-class');

var LoginBoxWrapper = require('../LoginBoxWrapper/LoginBoxWrapper.js');
var { Input, Button } = require('metro-ui-components');
var LoginHiddenFields = require('../Login/LoginHiddenFields.js');
var LoginHelper = require('../../utils/loginHelper.js');
var LoginHandler = require('../Login/LoginHandler.js');
var AuthMethodsHandler = require('../Login/AuthMethodsHandler.js')
var WebAuthn1FaWidget = require('../WebAuthnWidget/WebAuthn1FaWidget');

var Webauthn1FaLogin = createReactClass({
    displayName: 'Webauthn1FaLogin',

    getInitialState() {
        return {
            localeId: this.props.localeId,
            isWebauthnScreen: false
        };
    },
    
    componentDidMount: function () {
        LoginStore.webauthnCredentialsListener(this._on1FaWebauthnCredentialChange);
    },

    componentWillUnmount() {
        LoginStore.removeWebauthnCredentialsListener(this._on1FaWebauthnCredentialChange);
    },

    _on1FaWebauthnCredentialChange: function () {
        let appState = LoginStore.getState();
        this.onIsWebauthnScreenChange(appState.response1FaCredential);
        if(!appState.response1FaCredential) {
            LoginActions.triggerToast("Some error occured", "error", true);
            this.setState({ allowedCredentials: [] });
            this.setState({ challenge: "" });
            LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages['loginpreferences.1famethods.webauthn.init_session_expired']), "error", true);
        } else {
            this.setState({ allowedCredentials: appState.allowedCredentials });
            this.setState({ challenge: appState.challenge });
        }
    },

    renderFooter: function () {
        return (
            <IntlProvider
                locale={this.state.localeId}
                messages={this.props.translations}>
                <div className='fixFooterBottom'>
                    <Footer {...this.props} locale={this.state.localeId} onLocalChange={this.onLocalChange} />
                </div>
            </IntlProvider>
        )
    },

    onLogin(evt) {
        evt.preventDefault();
        LoginActions.get1faWebAuthnCredentialsForLogin(this.state.loginId, this.props.userType, this.props.clientId, this.props.realmId, this.props.initSessionId, this.props.traceId);
    },

    onIsWebauthnScreenChange(value) {
        this.setState({ isWebauthnScreen: value });
    },

    onLoginIdChange(e, value) {
        this.setState({ loginId: value });
    },

    onLocalChange(localeId) {
        this.setState({ localeId: localeId });
    },

    renderWebauthn1FaComponent() {
        return (
            <WebAuthn1FaWidget
                {... this.props}
                emailId = {this.state.loginId}
                initSessionId ={this.props.initSessionId}
                credentialId = {this.state.credentialId}
                challenge = {this.state.challenge}
                allowedCredentials = {this.state.allowedCredentials}
            />
        );
    },

    setLoginState(value) {
        this.setState(value)
    },

    renderLogin() {
        const label = this.props.intl.formatMessage(defaultMessages['userName']);
        const loginButtonText = this.props.intl.formatMessage(defaultMessages['loginBtnTxt']);

        return (
            <LoginBoxWrapper>
                <div>
                    <form id="authForm" noValidate="novalidate" onSubmit={this.onLogin} autoComplete="off" >
                        <Input
                            id="user_id"
                            type="email"
                            key="user_id"
                            name="user_id"
                            autoComplete="off"
                            label={label}
                            required={true}
                            hasWarning={this.state.loginError ? true : false}
                            value={this.state.loginId}
                            onChange={this.onLoginIdChange.bind(this)}
                            onKeyUp={this.onLoginIdChange.bind(this)}
                            onKeyDown={this.onLoginIdChange.bind(this)}
                            autoFocus={true}
                        />
                        <LoginHiddenFields {... this.props} />
                        <Button
                            id="submit"
                            type="submit"
                            value="submit"
                            kind="primaryRaised"
                            size="large"
                            className="primary-button"
                            disabled={!this.state.loginId}>
                            {loginButtonText}
                        </Button>
                    </form>
                    <div className="row">
                        <div className="forgotPasswordLink">
                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            </div>
                        </div>
                    </div>
                </div>
            </LoginBoxWrapper>
        );

    },

    renderContent: function () {
        let props = this.props;
        let bodyHeader = LoginHelper.getwelcomeToMetroDigitalText(props);
        let headerMessage = LoginHelper.getloginHeader(props);
        let renderedComponent = !this.state.isWebauthnScreen ? this.renderLogin() :
        this.renderWebauthn1FaComponent();

        return (
            <div className="portraitCenteredEmployee">
                <div className="welcomeTitle">
                    <span id="welcomeToMetroDigital">
                        {bodyHeader}
                    </span>
                </div>
                <div className="employeeBoxContainer container">
                    <div className="col-md-3 col-sm-2 col-xs-0" />
                    <div className="col-md-6 col-sm-8 col-xs-12 larger-device-width">
                        <div className="row whiteContainer larger-device-width smaller-device">
                            <div className="col-xs-12 smaller-device-inside-wrap">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div className="form-group centreAligned loginHeader">
                                            <span>{headerMessage}</span>
                                        </ div>
                                    </div>
                                </div>
                                {renderedComponent}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-2 col-xs-0" />
                </div>
                <LoginHandler {...props} localeId={this.state.localeId} userMFAMethods= {this.state.userMFAMethods} setState={this.setLoginState.bind(this)} />
                <AuthMethodsHandler {...props} setState={this.setLoginState.bind(this)}/>
            </div>
        );
    },

    render: function () {
        return (
            <PageCase
                header={<Header />}
                content={this.renderContent()}
                footer={this.renderFooter()}></PageCase>
        );
    }
});

module.exports = injectIntl(Webauthn1FaLogin);
